import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./components/HeroSection";
import BodySection from "./components/BodySection";
import AboutMe from "./components/AboutMe";
import Navbar from "./components/NavBar";
import Contactame from "./components/Contactme";
import FormacionSection from "./components/FormacionSection";
import TecnologiasSetion from "./components/TecnologiasSection";
import FooterSection from "./components/FooterSection";
import "./index.css";

function App() {
  const [language, setLanguage] = useState("es");

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  const jsonLD = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Julian Abril",
    "alternateName": "Julián Abril",
    "jobTitle": language === "es" ? "Desarrollador Full Stack & Ingeniero en Machine Learning" : "Full Stack Developer & Machine Learning Engineer",
    "url": "https://www.julianpril.com",
    "image": "https://www.julianpril.com/Preview.png",
    "email": "mailto:julianpril1482@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Tunja",
      "addressRegion": "Boyacá",
      "addressCountry": "CO"
    },
    "alumniOf": {
      "@type": "EducationalOrganization",
      "name": "Universidad de Boyacá",
      "url": "https://www.uniboyaca.edu.co"
    },
    "knowsAbout": [
      "Full Stack Development",
      "Machine Learning",
      "Artificial Intelligence",
      "React",
      "Python",
      "FastAPI",
      "PostgreSQL",
      "TypeScript",
      "React Native",
      "scikit-learn",
      "Streamlit",
      "Data Science",
      "Web Development",
      "Mobile Development"
    ],
    "sameAs": [
      "https://github.com/Julianpril",
      "https://www.linkedin.com/in/julianpril"
    ],
    "worksFor": {
      "@type": "Organization",
      "name": "Freelance Developer"
    },
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "name": "Hackathon Innovate Boyacá 2025",
        "description": "2do Puesto - Reto Empresarial Carvajal Laboratorios",
        "dateCreated": "2025"
      }
    ]
  };

  return (
    <div className="App bg-black text-white">
      <Helmet>
        <html lang={language === "es" ? "es" : "en"} />
        <title>
          {language === "es"
            ? "Julian Abril | Desarrollador Full Stack & Machine Learning - Portafolio"
            : "Julian Abril | Full Stack & Machine Learning Developer - Portfolio"}
        </title>
        <meta
          name="description"
          content={
            language === "es"
              ? "Portafolio de Julian Abril, Ingeniero de Sistemas con 2 años de experiencia en desarrollo Full Stack, Machine Learning e IA. Especializado en React, Python, FastAPI y soluciones empresariales SaaS. Proyectos reales con impacto."
              : "Portfolio of Julian Abril, Systems Engineer with 2 years of experience in Full Stack development, Machine Learning and AI. Specialized in React, Python, FastAPI and enterprise SaaS solutions. Real projects with impact."
          }
        />
        <meta
          name="keywords"
          content={
            language === "es"
              ? "Julian Abril, desarrollador full stack, machine learning, React, Python, FastAPI, ingeniero de sistemas, portafolio, desarrollo web, IA, inteligencia artificial, scikit-learn, Streamlit, PostgreSQL, React Native, TypeScript, Tunja, Boyacá, Colombia, SaaS, EmotionIA, Pawmi, MUUVA, QuickBite"
              : "Julian Abril, full stack developer, machine learning, React, Python, FastAPI, systems engineer, portfolio, web development, AI, artificial intelligence, scikit-learn, Streamlit, PostgreSQL, React Native, TypeScript, Tunja, Boyacá, Colombia, SaaS"
          }
        />
        <link rel="canonical" href="https://www.julianpril.com/" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.julianpril.com/" />
        <meta
          property="og:title"
          content={
            language === "es"
              ? "Julian Abril | Desarrollador Full Stack & Machine Learning"
              : "Julian Abril | Full Stack & Machine Learning Developer"
          }
        />
        <meta
          property="og:description"
          content={
            language === "es"
              ? "Portafolio profesional de Julian Abril. Desarrollador Full Stack especializado en React, Python, Machine Learning e IA. 2 años de experiencia creando soluciones innovadoras con impacto real."
              : "Professional portfolio of Julian Abril. Full Stack Developer specialized in React, Python, Machine Learning and AI. 2 years of experience creating innovative solutions with real impact."
          }
        />
        <meta property="og:image" content="https://www.julianpril.com/Preview.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content={language === "es" ? "Portafolio de Julian Abril - Desarrollador Full Stack" : "Julian Abril Portfolio - Full Stack Developer"} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:site_name" content="Julian Abril - Portfolio" />
        <meta property="og:locale" content={language === "es" ? "es_CO" : "en_US"} />
        <meta property="og:locale:alternate" content={language === "es" ? "en_US" : "es_CO"} />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.julianpril.com/" />
        <meta
          name="twitter:title"
          content={
            language === "es"
              ? "Julian Abril | Desarrollador Full Stack & Machine Learning"
              : "Julian Abril | Full Stack & Machine Learning Developer"
          }
        />
        <meta
          name="twitter:description"
          content={
            language === "es"
              ? "Portafolio profesional con proyectos reales en React, Python, Machine Learning e IA. 2 años de experiencia creando soluciones innovadoras."
              : "Professional portfolio with real projects in React, Python, Machine Learning and AI. 2 years of experience creating innovative solutions."
          }
        />
        <meta name="twitter:image" content="https://www.julianpril.com/Preview.png" />
        <meta name="twitter:image:alt" content={language === "es" ? "Portafolio de Julian Abril" : "Julian Abril Portfolio"} />
        <meta name="twitter:creator" content="@julianpril" />
        
        {/* Additional SEO */}
        <meta name="author" content="Julian Abril" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="language" content={language === "es" ? "Spanish" : "English"} />
        <meta name="revisit-after" content="7 days" />
        <meta name="rating" content="general" />
        <meta name="distribution" content="web" />
        
        {/* Geo Tags */}
        <meta name="geo.region" content="CO-BOY" />
        <meta name="geo.placename" content="Tunja, Boyacá, Colombia" />
        <meta name="geo.position" content="5.5354;-73.3677" />
        <meta name="ICBM" content="5.5354, -73.3677" />

        {/* Preconnect for performance */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />

        {/* Google Tag (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-G1KYKXTBDX"
        ></script>
        <script>
          {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-G1KYKXTBDX');`}
        </script>
      </Helmet>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }}
      />

      <header className="flex justify-center py-2">
        <Navbar onLanguageChange={handleLanguageChange} />
      </header>

      <main>
        <section id="inicio" className="py-2">
          <HeroSection language={language} />
        </section>
        <section id="proyectos" className="py-2">
          <BodySection language={language} />
        </section>
        <section id="tecnologias" className="py-2">
          <TecnologiasSetion language={language} />
        </section>
        <section id="formacion" className="py-2">
          <FormacionSection language={language} />
        </section>
        <section id="sobre-mi" className="py-2">
          <AboutMe language={language} />
        </section>
        <section id="contacto" className="py-2">
          <Contactame language={language} />
        </section>
      </main>

      <footer className="py-2">
        <FooterSection language={language} />
      </footer>
    </div>
  );
}

export default App;
